import React from 'react'

import Request from '@src/components/Request'

import * as style from './style.module.sass'

type RequestInfoProps = {
  requester: string
  isArtisan?: boolean
}

const RequestInfo: React.FC<RequestInfoProps> = ({ requester, isArtisan }) => (
  <>
    <p className={style.requester}>
      ※本記事は{requester}さんから
      <br />
      リクエストいただき取材・執筆しました。
    </p>
    <div className={style.button}>
      <Request isWhite isArtisan />
    </div>
  </>
)

export default RequestInfo
